import { useEffect, useState } from 'react';

function getSystemMode() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

/**
 * Reactive system color preference listener.
 */
export default function useSystemColorMode(enabled = true) {
  const [systemMode, setSystemMode] = useState(getSystemMode);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined' || !window.matchMedia) return undefined;

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (event) => {
      setSystemMode(event.matches ? 'dark' : 'light');
    };

    setSystemMode(media.matches ? 'dark' : 'light');
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, [enabled]);

  return systemMode;
}
